import { Component, OnInit } from '@angular/core';
import { TableColumn } from '@shared/interface/table.interface';
import { getDistributorTableColumns } from '../../../distributor.data';
import { BehaviorSubject } from 'rxjs';
import { UtilitiesService } from '@services/utilities.service';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { DistributorService } from '../../../distributor.service';
import { API } from '@config/constants/api.constant';

@Component({
  selector: 'app-teregistrasi-non-active',
  styleUrls: ['./teregistrasi-non-active.component.scss'],
  template: `
    <app-card-table-list
      [url]="API.LIST_DISTRIBUTOR_NON_ACTIVATED"
      [tableColumns]="tableColumns"
      [privilegeDetail]="privilegeDetailRegistered"
      [actionPathDetail]="distributorService.BasePathDistributorDetail + '/teregistrasi/nonactive/'"
      (totalCount)="onTotalCount($event)"
    />
  `,
})
export class TeregistrasiNonActiveComponent implements OnInit {
  tableColumns: TableColumn[] = getDistributorTableColumns('teregistrasi');
  privilegeDetailRegistered = new BehaviorSubject(false);

  public static totalCount = new BehaviorSubject(0);

  constructor(public utilities: UtilitiesService, private rolePrivilegeService: RolePrivilegeService, public distributorService: DistributorService) {}

  ngOnInit() {
    this.privilegeDetailRegistered.next(this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_TEREGISTRASI', 'TAB_LIST_NONACTIVATED', 'CTA_VIEW_DETAIL'));
    this.tableColumns = this.utilities.privilegeTableColumns(this.privilegeDetailRegistered.value, this.tableColumns);
  }

  onTotalCount = (e: number) => TeregistrasiNonActiveComponent.totalCount.next(e);

  protected readonly API = API;
}
